import React, { useState } from 'react';
import { FolderDetailsArgs, FolderDetailsQuery, FolderDetailsResponse, RepoItem } from '../../autogenerated/ZoomBridge';
import { Chart } from '../../common/chart/Chart';
import ExpandButtonWithText from '../../common/ExpandButtonWithText';
import t from '../../i18n/I18n';
import ConfirmModal from '../../modals/confirm/ConfirmModal';
import Modal2 from '../../modals/Modal2';
import Separator from '../../common/form/Separator';

export const FolderDetails = ({ onClose, assets }) => {
  const [isConfirmed, setisConfirmed] = useState(false);
  const [folderData, setFolderData] = useState({});
  const confirmYes = () => {
    const asset: RepoItem = assets[0];
    const queryMessage = new FolderDetailsArgs();
    queryMessage.setFuid(asset.getFuid());
    queryMessage.setBid(asset.getBid());
    queryMessage.setRrn(asset.getRrn());
    const query = new FolderDetailsQuery();
    query.message = queryMessage;
    query.run().then((data: FolderDetailsResponse) => {
      const items = [];
      items.push({ name: t('FOLDER_DETAILS.DELETED_FILES'), value: data.getDeletedFilesCount(), color: "#B93A36" });
      items.push({ name: t('FOLDER_DETAILS.ARCHIVE_FILES'), value: data.getArchiveFilesCount(), color: "#AA8859" });
      items.push({ name: t('FOLDER_DETAILS.EXPRIED_FILES'), value: data.getExpiredCount(), color: "#7C7C7C" });
      items.push({ name: t('FOLDER_DETAILS.ACTIVE_FILES'), value: data.getTotalFiles() - data.getExpiredCount() - data.getArchiveFilesCount(), color: "#52BE80" });

      setFolderData({
        items,
        totalFiles: data.getTotalFiles() + data.getDeletedFilesCount(),
        subfolders: data.getFoldersCount(),
        folderSize: data.getFolderSize()
      });
      setisConfirmed(true);
    });
  };
  if (!isConfirmed) {
    return (
      <ConfirmModal
        onClose={() => {
          onClose();
        }}
        message={t('FOLDER_DETAILS.FOLDER_DETAILS_CONFIRM_MSG')}
        title={t('CONFIRM')}
        moveAsset={confirmYes}
        onCross={() => {
          onClose();
        }}
      />
    );
  }
  return (
    <Modal2
      closeOnEsc
      closeOnOutsideClick={false}
      onClose={onClose}
      buttons={[{ label: t('CLOSE'), type: 'CANCEL', onClick: onClose }]}
      name="FolderDetailsModal"
      title={t('FOLDER_DETAILS.FOLDER_DETAILS_TITLE')}>
      {isConfirmed ? (
        <div className="row" style={{ fontSize: '12px' }}>
          <div className="flex-row" style={{ width: '100%'}}>
           
            <FolderDetailsItems
              title={`${t('FOLDER_DETAILS.TOTAL_FILES')}: ${folderData.totalFiles}`}
              items={folderData.items}
            />
            <Separator style={{margin: 'unset', height: '100%', width: 1}}/>
            <FolderDetailsItems 
            title={t('FOLDER_DETAILS.FOLDER_DETAILS_OPTION')} 
            items = {[
              {name: t('FOLDER_DETAILS.SIZE'), value: folderData.folderSize}, 
              {name: t('FOLDER_DETAILS.SUB_FOLDER'), value: folderData.subfolders}
             ]}
            />
          </div>
          {/* <Separator style={{margin: 'unset'}}/> */}
          <div className="col">
            <Chart data={_.filter(folderData.items, (o)=>o.value)} />
          </div>
        </div>
      ) : null}
    </Modal2>
  );
};

const FolderDetailsItems = ({ items, title }) => {
  const [isExpend, setisExpend] = useState(true);
  return (
    <div className="col" style={{height: 215}}>
      <div className="col-12">
        <ExpandButtonWithText isExpanded={isExpend} text={title} onClick={() => setisExpend(!isExpend)} />
      </div>
      {isExpend && (
        <div className="">
          <ul>
            {items.map((e, i) => (
              <li key={i}>
                <span className="mr-2 folder-details-list-item">{e.name} </span>
                {e.value}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
